import React from 'react'
import PropTypes from 'prop-types'
import InquireForm from './form'

const InquireForms = ({ form, initialValues, ...props }) => {
  return <InquireForm form={form} initialValues={initialValues} {...props} />
}

InquireForms.propTypes = {
  handleSubmit: PropTypes.func,
  submitButtonTitle: PropTypes.string,
  initialValues: PropTypes.object,
  form: PropTypes.string,
}

export default InquireForms
